module.exports = __webpack_public_path__ + "img/zhAward-2.62af0268.png";